// lodash
import _find from 'lodash/find';

// constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// readers
import { filterReader } from '../readers/FilterGroup';
var isSelectedFilterType = function isSelectedFilterType(filter) {
  return function () {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
    var id = filterType.id;
    return id === filterReader.type(filter);
  };
};
var getTypeOfFilter = function getTypeOfFilter(filterTypes, filter) {
  var filterType = _find(filterTypes, isSelectedFilterType(filter));
  var _ref = filterType || EMPTY_OBJECT,
    type = _ref.type;
  return type;
};
export default getTypeOfFilter;